define([
    "jquery",
    "underscore",
    "marionette",
    "google_analytics",
    "forms/deposit/deposit_raga_pay_form",
    "behaviors/form_errors_behavior",
    "backbone.syphon"
], function($, _, Marionette, GoogleAnalytics, RagaPayForm, FormErrorsBehavior) {

    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {
            'depositBtn':'#deposit_btn',
            'form' :'#form_submit',
        },

        events:{
            'click @ui.depositBtn' : 'submit'
        },

        initialize: function(){
            this.bindUIElements();


            GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.trust_open_amount);
        },

        submit: function(e){
            if(e) e.preventDefault();
            this.triggerMethod('hide:errors');

            var formData = Backbone.Syphon.serialize(this.$('#form_submit')[0]);
            var form = new RagaPayForm();

            form.set(formData);
            var errors = form.validate();

            var that = this;
            if(_.size(errors) <1){
                form.validateWithServer({
                    type: 'POST',
                    success: function(model, res){
                        that.ui.form.submit();

                        GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.trust_pageout);
                    },
                    error: function(model, error){
                        that.triggerMethod('show:errors', error.responseJSON);
                    }
                })
            }else{
                this.triggerMethod('show:errors', errors);
            }

            // this.ui.form.submit();
        },

        deposit: function(e) {
            if(e) e.preventDefault();

            this.triggerMethod('hide:errors');

            var formData = Backbone.Syphon.serialize(this.$('#form_submit')[0]);
            var form = new RagaPayForm();

            form.set( formData);
            var errors = form.validate();

            var that = this;
            if(_.size(errors) < 1){
                form.validateWithServer({
                    type: 'POST',
                    success: function(model, res){
                        that.$('#form_submit').submit();
                    },
                    error: function(model, error){
                        // console.log(error);
                        // that.triggerMethod('show:errors', error.responseJSON);
                    }
                });
            }else{
                this.triggerMethod('show:errors', errors);
            }
        },
    });
});
